import { useUserDeviceList } from 'api/goodtrust/user/device'
import { Button } from 'components/button/Button'
import { DeviceCard } from 'components/device/deviceCard/DeviceCard'
import { Stack } from 'components/Stack'
import { WizardContentHeading } from 'components/wizard/wizardContent/WizardContent'
import { SWizardGrid } from 'components/wizard/wizardGridCard/WizardGridCard'
import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'
import { getPaginationMeta } from 'utils/pagination'

export function DeviceList(props: { title: string }) {
  const { t } = useTranslation('digital_vault')
  const { t: tCommon } = useTranslation()

  const devices = useUserDeviceList()
  const meta = getPaginationMeta(devices)
  return (
    <section>
      <WizardContentHeading
        title={props.title}
        action={
          <Button variant="text" href="/me/device/add" type="button" fitContentVertically>
            {t('digital_vault.inside_page.devices_tab.devices_list_button')}
          </Button>
        }
      />
      <Stack space={'0.875rem'}>
        <div css={{ width: '100%' }}>
          {!meta.isLoadingInitial && (
            <SWizardGrid multiRow>
              {devices.data?.map((page, pageIndex) => (
                <Fragment key={pageIndex}>
                  {page?.json?.items?.map((device) => {
                    return (
                      <DeviceCard device={device} onDataChange={devices.mutate} key={device.uuid} />
                    )
                  })}
                </Fragment>
              ))}
            </SWizardGrid>
          )}
        </div>

        {!meta.isReachingEnd && (
          <Button
            type="button"
            variant="secondary"
            size="large"
            loading={meta.isLoadingMore}
            onClick={meta.handleLoadMore}
            block
            data-testid="load-more-button"
          >
            {tCommon('common.load_more')}
          </Button>
        )}
      </Stack>
    </section>
  )
}
